import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Terminos from "@/pages/Terminos";
import Privacidad from "@/pages/Privacidad";
import Aprende from "@/pages/Aprende";
import Dashboard from "@/pages/Dashboard";
import Wines from "@/pages/Wines";
import WineForm from "@/pages/WineForm";
import History from "@/pages/History";
import Compare from "@/pages/Compare";
import TastingForm from "@/pages/TastingForm";
import TastingDetail from "@/pages/TastingDetail";
import Community from "@/pages/Community";
import Admin from "@/pages/Admin";
import Layout from "@/components/Layout";
import { Wine } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-blanco-off">
        <Wine className="w-10 h-10 text-borgona-700 animate-pulse" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function PublicRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
        <Route path="/recuperar" element={<ForgotPassword />} />
        <Route path="/terminos" element={<Terminos />} />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/aprende" element={<Aprende />} />
        <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/app/vinos" element={<ProtectedRoute><Wines /></ProtectedRoute>} />
        <Route path="/app/vinos/nuevo" element={<ProtectedRoute><WineForm /></ProtectedRoute>} />
        <Route path="/app/vinos/:id/editar" element={<ProtectedRoute><WineForm /></ProtectedRoute>} />
        <Route path="/app/historial" element={<ProtectedRoute><History /></ProtectedRoute>} />
        <Route path="/app/comparar" element={<ProtectedRoute><Compare /></ProtectedRoute>} />
        <Route path="/app/catas/nueva" element={<ProtectedRoute><TastingForm /></ProtectedRoute>} />
        <Route path="/app/catas/:id/editar" element={<ProtectedRoute><TastingForm /></ProtectedRoute>} />
        <Route path="/app/catas/:id" element={<ProtectedRoute><TastingDetail /></ProtectedRoute>} />
        <Route path="/app/comunidad" element={<ProtectedRoute><Community /></ProtectedRoute>} />
        <Route path="/app/comunidad/:id" element={<ProtectedRoute><TastingDetail community /></ProtectedRoute>} />
        <Route path="/app/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
